export const Match = 1;
export const MatchPoints = 2;
export const FirstPeriod = 3;
export const SecondPeriod = 4;
export const ThirdPeriod = 5;
export const FourthPeriod = 6;
export const FifthPeriod = 7;
export const SixthPeriod = 8;
export const SeventhPeriod = 9;
export const EighthPeriod = 10;
export const TennisServe = 40;
export const RedCard = 41;
export const Penalty = 42;
export const YellowCard = 43;
export const CurrentGame = 44;
export const PowerPlay = 45;
export const Feed = 46;
export const Overtime = 47;
export const Corner = 48;
export const BallPossession = 49;
export const Timeout = 50;
export const FirstPeriodFouls = 51;
export const SecondPeriodFouls = 52;
export const ThirdPeriodFouls = 53;
export const FourthPeriodFouls = 54;
export const PenaltySeries = 55;
export const ExtraTime = 56;


// WEBPACK FOOTER //
// ./js/constants/ScoreType.js